import moment from 'moment'
import { useState } from 'react'
import { DATE_WEEKDAY_FORMAT, TIME_FORMAT } from '../constants'
import { usePodModalProps } from '../hooks/use-pod-modal-props'
import { JobAuditItem } from '../interfaces'
import { isLeftSafe } from '../utils'
import { Col, Row } from './flex'
import { PodModal } from './pod-modal'
import { PrimaryText, Text } from './text'

interface JobLogProps {
    jobAudit?: JobAuditItem[]
}

export const JobLog = ({ jobAudit }: JobLogProps) => {
    const [showModal, setShowModal] = useState(false)
    const [auditItem, setAuditItem] = useState<JobAuditItem>()
    const modalProps = usePodModalProps(auditItem)
    const openModal = (auditItem: JobAuditItem) => {
        setAuditItem(auditItem)
        setShowModal(true)
    }
    const closeModal = () => {
        setShowModal(false)
    }

    const sorted = jobAudit?.sort((a, b) =>
        moment(a.dateTime).diff(moment(b.dateTime)) > 0 ? -1 : 1,
    )

    return (
        <>
            {sorted?.map((auditItem, index, array) => {
                const { dateTime, description, POD } = auditItem
                const time = moment(dateTime).format(TIME_FORMAT)
                const date = moment(dateTime).format(DATE_WEEKDAY_FORMAT)
                const previousDate =
                    index > 0
                        ? moment(array[index - 1].dateTime).format(
                              DATE_WEEKDAY_FORMAT,
                          )
                        : ''
                return (
                    <Col key={index}>
                        {date !== previousDate && (
                            <div className="bg-gray-100 px-4 py-2 mb-4">
                                <PrimaryText>{date}</PrimaryText>
                            </div>
                        )}
                        <Row key={index} className="pb-2 pl-4 sm:pl-14">
                            <PrimaryText className="w-14">{time}</PrimaryText>
                            <Text className="flex-grow">{description}</Text>
                            {POD?.signature && (
                                <>
                                    <button
                                        className="text-blue-500 text-sm underline"
                                        onClick={() => openModal(auditItem)}>
                                        {isLeftSafe(POD.name)
                                            ? 'View left safe photo'
                                            : 'View signature'}
                                    </button>
                                </>
                            )}
                        </Row>
                    </Col>
                )
            })}
            {showModal && <PodModal onClose={closeModal} {...modalProps} />}
        </>
    )
}
